var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_1262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.39705 14.5266C9.63652 13.4564 13.3276 9.99127 13.3276 6.66404C13.3276 5.25016 12.7659 3.89419 11.7662 2.89443C10.7664 1.89467 9.41044 1.33301 7.99656 1.33301C6.58268 1.33301 5.22671 1.89467 4.22695 2.89443C3.22719 3.89419 2.66553 5.25016 2.66553 6.66404C2.66553 9.99127 6.3566 13.4564 7.59607 14.5266C7.71153 14.6135 7.85209 14.6604 7.99656 14.6604C8.14103 14.6604 8.28159 14.6135 8.39705 14.5266Z",
    stroke: "#99A1AF",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99645 8.66331C9.10055 8.66331 9.99559 7.76827 9.99559 6.66418C9.99559 5.56008 9.10055 4.66504 7.99645 4.66504C6.89236 4.66504 5.99731 5.56008 5.99731 6.66418C5.99731 7.76827 6.89236 8.66331 7.99645 8.66331Z",
    stroke: "#99A1AF",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_1262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9931,
    height: 15.9931,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b4af906daaec6042f3086b3a14f19af0.svg";
export { ForwardRef as ReactComponent };